export default "__VITE_ASSET__e441c7f0__"